import React from 'react';
import Calendar from './calendar.js';

export default class Timesheet extends React.Component {
  render() {
    return (
      <div className='contentwrapper bravo-ds'>
        <div id='divTimesheet' className='at-page'>
          <Calendar />
        </div>
      </div>
    );
  }
}
